// extracted by mini-css-extract-plugin
export var brand = "_2z-9";
export var compact = "_2z-6";
export var extraSmall = "_2z-7";
export var icon = "_2z-0";
export var large = "_2z-4";
export var light = "_2z-1";
export var medium = "_2z-5";
export var outline = "_2z-b";
export var primaryDark = "_2z-a";
export var primaryLight = "_2z-8";
export var primaryModern = "_2z-c";
export var success = "_2z-2";
export var successSolid = "_2z-3";